import "@hotwired/turbo-rails"
import "./controllers"
import "./posthog_widget_persistence"

let isForwardNavigation = false
document.addEventListener("turbo:before-visit", () => { isForwardNavigation = true })
document.addEventListener("turbo:load", () => {
    if (isForwardNavigation) {
        isForwardNavigation = false
        window.scrollTo(0, 0)
    }
})

import "leaflet"
